import NavigationIcon from '@mui/icons-material/Navigation';
import { SvgIconProps } from '@mui/material';
import { AngleUnits } from 'convert-units/definitions/angle';
import { useMemo } from 'react';

import { convert } from '@/common/convert';

export type DirectionIconProps = {
    heading: number;
    /**
     * If the data represents the `source`, the arrow will point away from the heading (common for wind, waves);
     * if the data represents the `flow`, the arrow will point toward the heading.
     */
    type: 'source' | 'flow';
    unit?: AngleUnits;
};

export const DirectionIcon = ({ heading, type, unit = 'deg', sx, ...props }: SvgIconProps & DirectionIconProps) => {
    const rotation = useMemo(() => {
        const headingDegrees = convert(heading).from(unit).to('deg');
        switch (type) {
            case 'source':
                return Math.round((headingDegrees + 180) % 360);
            case 'flow':
                return Math.round(headingDegrees % 360);
        }
    }, [heading, type, unit]);
    return <NavigationIcon sx={{ transform: `rotate(${rotation}deg)`, fontSize: '1.25em', ...sx }} {...props} />;
};
